const skillData = [
  {
    id: "1",
    title: "HTML",
    src: "./images/01_html.png",
    alt: "HTML",
  },

  // {
  //   id: "2",
  //   title: "CSS",
  //   src: "./images/02_css.png",
  //   alt: "CSS",
  // },

  {
    id: "3",
    title: "JavaScript",
    src: "./images/03_javascript.png",
    alt: "JavaScript",
  },

  {
    id: "4",
    title: "React",
    src: "./images/04_react.png",
    alt: "React",
  },

  {
    id: "5",
    title: "React Native",
    src: "./images/05_reactNative.png",
    alt: "React Native",
  },

  {
    id: "6",
    title: "Tailwind",
    src: "./images/06_tailwind.png",
    alt: "Tailwind",
  },

  {
    id: "7",
    title: "SQL",
    src: "./images/07_sql.png",
    alt: "SQL",
  },

  // {
  //   id: "8",
  //   title: "TypeScript",
  //   src: "./images/08_typescript.png",
  //   alt: "TypeScript",
  // },

  // {
  //   id: "9",
  //   title: "NodeJS",
  //   src: "./images/09_node.png",
  //   alt: "NodeJS",
  // },

  // {
  //   id: "10",
  //   title: "NEXT.JS",
  //   src: "./images/10_nextjs.png",
  //   alt: "NEXT.JS",
  // },

  {
    id: "11",
    title: "git",
    src: "./images/11_git.png",
    alt: "git",
  },

  {
    id: "12",
    title: "GitHub",
    src: "./images/12_github.png",
    alt: "GitHub",
  },
];

export default skillData;
